var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 3.33335C6.31806 3.33335 3.33329 6.31812 3.33329 10C3.33329 13.6819 6.31806 16.6667 9.99996 16.6667C13.6819 16.6667 16.6666 13.6819 16.6666 10C16.6666 6.31812 13.6819 3.33335 9.99996 3.33335ZM1.66663 10C1.66663 5.39765 5.39759 1.66669 9.99996 1.66669C14.6023 1.66669 18.3333 5.39765 18.3333 10C18.3333 14.6024 14.6023 18.3334 9.99996 18.3334C5.39759 18.3334 1.66663 14.6024 1.66663 10Z",
    fill: "#3A2CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27771 7.91725C9.04726 8.31563 8.53748 8.45177 8.1391 8.22132C7.74072 7.99086 7.60458 7.48109 7.83503 7.08271C8.26604 6.33763 9.07367 5.83331 10.0001 5.83331C11.3808 5.83331 12.5001 6.9526 12.5001 8.33331C12.5001 9.24808 11.9389 9.99496 11.2501 10.4166C10.6967 10.7554 11.0417 11.6666 9.99788 11.6666C9.53765 11.6666 9.16455 11.2935 9.16455 10.8333C9.16455 10.8041 9.16606 10.7751 9.169 10.7467C9.19211 10.3059 9.38863 9.94735 9.6026 9.6866C9.82858 9.41121 10.1257 9.18641 10.3529 9.05135C11.6168 8.29998 10.0752 6.76281 9.27771 7.91725ZM9.99788 12.5C9.53765 12.5 9.16455 12.8731 9.16455 13.3333C9.16455 13.7935 9.53765 14.1666 9.99788 14.1666C10.4581 14.1666 10.8312 13.7935 10.8312 13.3333C10.8312 12.8731 10.4581 12.5 9.99788 12.5Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.3ad13a40f26fb86f20fcf2abd5149f24.svg";
export { ForwardRef as ReactComponent };